module.exports = __webpack_public_path__ + "static/media/image_48.754fe7f0.png";